import React, { useEffect } from 'react'

import { Box, Button, TextField, Typography } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'

import { BasePhoneInput } from 'components'
import schema from './schema'
import useStyles from './styles'

const Initials = ({ name, classes }) => {
  const letters = (name || '')
    .split(' ')
    .filter((word) => !isEmpty(word))
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('')

  return (
    <Box className={classes.avatar}>
      <Typography className={classes.avatarLetters}>
        {letters || '?'}
      </Typography>
    </Box>
  )
}

const ProfileForm = ({ profile, onSave, isSaving }) => {
  const classes = useStyles()

  const { handleSubmit, errors, control, reset, watch } = useForm({
    validationSchema: schema,
    defaultValues: {
      name: '',
      email: '',
      phone: '',
    },
  })

  useEffect(() => {
    if (profile) {
      reset({
        name: profile.name || '',
        email: profile.email || '',
        phone: profile.phone || '',
      })
    }
  }, [profile, reset])

  const watchedName = watch('name')
  const watchedEmail = watch('email')
  const watchedPhone = watch('phone')

  const hasChanges =
    watchedName !== (profile?.name || '') ||
    watchedEmail !== (profile?.email || '') ||
    watchedPhone !== (profile?.phone || '')

  return (
    <Box className={classes.root}>
      <Typography className={classes.sectionLabel}>PERFIL</Typography>
      <Box className={classes.inner}>
        <Box className={classes.avatarColumn}>
          <Initials name={watchedName} classes={classes} />
          <Typography className={classes.displayName}>{watchedName}</Typography>
          <Typography className={classes.displayEmail}>
            {watchedEmail}
          </Typography>
        </Box>

        <Box
          className={classes.formColumn}
          component="form"
          onSubmit={handleSubmit(onSave)}
        >
          <Controller
            as={
              <TextField
                label="Nome"
                variant="outlined"
                fullWidth
                error={!!errors.name}
                helperText={errors?.name?.message}
              />
            }
            control={control}
            name="name"
            mode="onBlur"
          />
          <Controller
            as={
              <TextField
                label="E-mail"
                variant="outlined"
                fullWidth
                type="email"
                error={!!errors.email}
                helperText={errors?.email?.message}
              />
            }
            control={control}
            name="email"
            mode="onBlur"
          />
          <Controller
            as={
              <BasePhoneInput
                label="Telefone"
                error={!!errors?.phone}
                helperText={
                  errors?.phone?.message ||
                  'Adicione o código do país e o DDD do seu telefone'
                }
                fullWidth
              />
            }
            control={control}
            name="phone"
            mode="onBlur"
          />
          <Box className={classes.saveRow}>
            <Button
              type="submit"
              variant="contained"
              disabled={isSaving || !hasChanges}
              className={classes.saveButton}
            >
              {isSaving ? 'Salvando...' : 'Salvar alterações'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ProfileForm
